export default function Disclaimer() {
  return (
    <div className="max-w-[820px] mx-auto px-6 lg:px-12 py-14 lg:py-20" data-testid="disclaimer-page">
      <p className="overline mb-4">Policy</p>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tight mb-10">Research-Use Disclaimer.</h1>
      <div className="hairline mb-10" />

      <div className="text-charcoal text-[17px] md:text-[18px] leading-[1.75] space-y-6">
        <p>
          All products on this site are for research and development use only. Products are not for
          human consumption. The statements made on this website have not been evaluated by the US
          Food and Drug Administration. The statements and the products of this company are not
          intended to diagnose, treat, cure, or prevent any disease.
        </p>

        <p>
          BULKBUYKITS.com and Research 1617 are not compounding pharmacies or chemical compounding
          facilities as defined under 503A of the Federal Food, Drug, and Cosmetic Act.
          BULKBUYKITS.com and RESEARCH 1617 are not outsourcing facilities as defined under 503B of
          the Federal Food, Drug, and Cosmetic Act.
        </p>

        <div className="hairline my-12" />

        <p className="text-[15px] text-stone">
          Questions? Reach us at{" "}
          <a
            href="mailto:support@bulkbuykits.com"
            className="text-oxblood hover:text-charcoal underline"
            data-testid="disclaimer-support-email"
          >
            support@bulkbuykits.com
          </a>
          .
        </p>
      </div>
    </div>
  );
}
